// Servicio para consultar habilidades desde ESCO y GitHub Topics
const ESCO_API_URL = 'https://ec.europa.eu/esco/api/search';
const GITHUB_API_URL = 'https://api.github.com/search/topics';

// Función auxiliar para buscar en GitHub
const searchGithub = async (query) => {
  try {
    const response = await fetch(`${GITHUB_API_URL}?q=${encodeURIComponent(query)}`, {
      headers: {
        Accept: 'application/vnd.github+json',
      },
    });

    if (!response.ok) return [];

    const data = await response.json();
    return (data.items || []).map((item) => ({
      id: `gh-${item.name}`, // ID único con prefijo
      label: item.display_name || item.name,
      source: 'GITHUB',
    }));
  } catch (error) {
    console.error('Error fetching GitHub topics:', error);
    return [];
  }
};

// Función auxiliar para buscar en ESCO
const searchEsco = async (query) => {
  try {
    const url = `${ESCO_API_URL}?text=${encodeURIComponent(
      query
    )}&language=es&type=skill&isInScheme=http://data.europa.eu/esco/concept-scheme/skills&limit=15`;

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) return [];

    const data = await response.json();
    const results = data._embedded?.results || [];

    return results.map((item) => {
      // Extraemos el texto en español o usamos el título por defecto
      const labelStr =
        item.title ||
        (item.preferredLabel && item.preferredLabel.es ? item.preferredLabel.es : item.title);

      return {
        id: item.uri,
        label: labelStr,
        source: 'ESCO',
      };
    });
  } catch (error) {
    console.error('Error fetching ESCO skills:', error);
    return [];
  }
};

// Función principal que combina ambas búsquedas
export const searchEscoSkills = async (query) => {
  if (!query || query.length < 3) return [];

  // Ejecutamos ambas peticiones en paralelo para que sea rápido
  const [escoResults, githubResults] = await Promise.all([searchEsco(query), searchGithub(query)]);

  // Combinamos resultados
  // Ponemos GitHub primero porque suele ser más relevante para tech (ej: "react", "powerbi")
  const combined = [...githubResults, ...escoResults];

  // Eliminamos duplicados exactos de nombre (por si acaso)
  const uniqueResults = [];
  const map = new Map();

  for (const item of combined) {
    const normalized = item.label.toLowerCase().trim();
    if (!map.has(normalized)) {
      map.set(normalized, true);
      uniqueResults.push(item);
    }
  }

  return uniqueResults;
};
